import { NgIf, NgFor } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatLabel, MatSuffix, MatError } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatTooltip } from '@angular/material/tooltip';
import { LocaleService, TranslatePipe } from '@next/core-lib/i18n';

import {
  FreshnessType,
  TailDamageType,
  TailLengthType,
  TailPosition,
} from '../../model/tail-biting.model';

@Component({
  selector: 'app-tail-biting-detail-pen-form',
  templateUrl: './tail-biting-detail-pen-form.component.html',
  styleUrls: ['./tail-biting-detail-pen-form.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatSuffix,
    NgIf,
    MatError,
    MatIcon,
    MatTooltip,
    MatSelect,
    NgFor,
    MatOption,
    MatButton,
    TranslatePipe,
  ],
})
export class TailBitingDetailPenFormComponent implements OnInit, OnChanges {
  @Input() isMobile: boolean;
  @Input() penFormGroup: FormGroup;
  @Input() index: number;
  @Input() canDelete: boolean;

  @Output() deletePen = new EventEmitter<number>();

  tailLengthTypes: TailLengthType[] = Object.values(TailLengthType);
  tailPositionsTypes: TailPosition[] = Object.values(TailPosition);
  tailDamageTypes: TailDamageType[] = Object.values(TailDamageType);
  freshnessTypes: FreshnessType[] = Object.values(FreshnessType);

  showTailPositionType = false;
  showTailFreshnessType = false;

  constructor(private readonly localeService: LocaleService) {}
  ngOnInit(): void {
    this.setValueChanges();
  }

  ngOnChanges(): void {
    this.setValueChanges();
  }

  public delete() {
    this.deletePen.emit(this.index);
  }

  setValueChanges() {
    this.penFormGroup.controls.tailLength.valueChanges.subscribe(() => {
      this.setshowTailPositionType();
    });

    this.penFormGroup.controls.tailDamage.valueChanges.subscribe(() => {
      this.setshowfreshnessTypeType();
    });

    this.setshowTailPositionType();
    this.setshowfreshnessTypeType();
  }

  setshowTailPositionType() {
    switch (this.penFormGroup.controls.tailLength.value) {
      case 'Full':
      case 'PartiallyShortend':
        this.showTailPositionType = true;
        this.penFormGroup.controls.tailPosition.addValidators(Validators.required);
        this.penFormGroup.controls.tailPosition.updateValueAndValidity();
        break;
      case 'Short':
        this.showTailPositionType = false;
        this.penFormGroup.controls.tailPosition.clearValidators();
        this.penFormGroup.controls.tailPosition.setValue(undefined);
        this.penFormGroup.controls.tailPosition.updateValueAndValidity();
        break;
    }
  }

  setshowfreshnessTypeType() {
    switch (this.penFormGroup.controls.tailDamage.value) {
      case 'BiteMarks':
      case 'Wound':
      case 'InflamedWound':
        this.showTailFreshnessType = true;
        this.penFormGroup.controls.freshness.addValidators(Validators.required);
        this.penFormGroup.controls.freshness.updateValueAndValidity();
        break;
      case 'NoDamage':
        this.showTailFreshnessType = false;
        this.penFormGroup.controls.freshness.clearValidators();
        this.penFormGroup.controls.freshness.setValue(undefined);
        this.penFormGroup.controls.freshness.updateValueAndValidity();
        break;
    }
  }

  getToolTip(item: string) {
    return this.localeService.translate(item).replace(/\\n/g, '\n').replace('\\n', '\n');
  }
}
